import React, { FC } from 'react';
import styled from 'styled-components';

interface PlayPauseProps {
  theme?: string;
  isPlaying: boolean;
  onClick: () => void;
  className?: string;
}

const Button = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const IconBase = styled.svg<{ theme?: string }>`
  width: 32px;
  height: 32px;
  fill: ${({ theme }) => (theme == 'dark' ? '#fff' : '#191A1F')};
`;

const PauseIcon: FC<{ theme?: string }> = ({ theme }) => (
  <IconBase viewBox="0 0 32 32" role="img" aria-label="Pause" theme={theme}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 11C14 10.4477 13.5523 10 13 10C12.4477 10 12 10.4477 12 11V21C12 21.5523 12.4477 22 13 22C13.5523 22 14 21.5523 14 21V11ZM20 11C20 10.4477 19.5523 10 19 10C18.4477 10 18 10.4477 18 11V21C18 21.5523 18.4477 22 19 22C19.5523 22 20 21.5523 20 21V11Z"
    />
  </IconBase>
);

const PlayIcon: FC<{ theme?: string }> = ({ theme }) => (
  <IconBase viewBox="0 0 32 32" role="img" aria-label="Play" theme={theme}>
    <polygon points="12,10 24,16 12,22" />
  </IconBase>
);

const PlayPause: FC<PlayPauseProps> = ({ isPlaying, onClick, className, theme }) => (
  <Button onClick={onClick} className={className}>
    {isPlaying ? <PauseIcon theme={theme} /> : <PlayIcon theme={theme} />}
  </Button>
);

export default PlayPause;